import { Row } from "./Row";
import { WSCCard } from "./WSCCard";
export class WSCRow extends Row {
    static _template() {
        return Object.assign(Object.assign({}, super._template()), { h: this.H });
    }
    set title(title) {
        super.title = title;
        this.patch({
            h: title ? WSCRow.H : WSCCard.H,
            Title: { y: 12.5, text: { fontFace: "Lato", letterSpacing: -0.64 } },
            List: { y: title ? 79 : 0 },
        });
    }
    createCard(item) {
        return Object.assign(Object.assign({}, super.createCard(item)), { title: item.title, type: WSCCard });
    }
}
WSCRow.H = 79 + WSCCard.H;
export default WSCRow;
//# sourceMappingURL=WSCRow.js.map